import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { PoliciesService } from 'src/app/shared/services/policyservices/policies.service';
import Swal from 'sweetalert2';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';


@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrl: './policy.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class PolicyComponent implements OnInit {
  public showSpinner = true;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  policyDetail: any;
  editorContent = '';
  editorConfig = {};
  constructor(
    public _location: Location,
    private sharedmode: SharedModeService,
    private policyService: PoliciesService,
    public router: Router,
    public dashboardService: DashboardService,
    private settings: SettingservicesService,


  ) {
    this.user_detail();

  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getpolicy()
  }

  getpolicy() {
    this.showSpinner = true;
    this.policyService.getPolicy().then((value) => {
      this.policyDetail = value.data

    })
    this.showSpinner = false;
  }


  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })
  }

  deletepolicy(id: any) {
    this.showSpinner = true;
    this.settings.getpolicydelete(id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
      window.location.reload()
    })
  }


  editPolicy(data: any) {
    const uuid = data.uuid
    this.router.navigate(['/add-policy', uuid]);
    this.policyService.policyData(uuid).then((value) => {
    });

  }



}